import React from "react";
import PropTypes from 'prop-types';
import CONST from "../../config/CONST";

const InitializationErrorMessage = (props) => {
    const {
        error
    } = props;

    return (
        <div className={`${CONST.CSS_NAMESPACE}InitializationErrorMessage`}>
            <p>{ error }</p>
        </div>
    )
}


InitializationErrorMessage.propTypes = {
    error: PropTypes.string.isRequired
}

export default InitializationErrorMessage;
